import { jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import React from 'react';
import UniversalNavLink from '../../UniversalNavLink';
import { Divider } from '../Divider';
import { isLinkSelected } from './utils';
import { MoreLinksMenu } from './MoreLinksMenu';
import { boxSizing, listReset } from '../../../../utils/style-mixins/reset';
const Styles = labelStyles('InAppLinks', {
    linkGroup: Object.assign(Object.assign({}, listReset), { display: 'flex', flexDirection: 'column', gap: 'var(--zds-space-4, 4px)', margin: 0, padding: 0 }),
    links: Object.assign(Object.assign({}, listReset), { alignContent: 'start', display: 'grid', listStyle: 'none', padding: '0 var(--zds-space-8, 8px)' }),
    moreLink: Object.assign(Object.assign({}, boxSizing), { marginTop: 'var(--zds-space-4, 4px)' }),
});
const InAppLinks = ({ links, moreLinks, selectedHref }) => (jsx(React.Fragment, null,
    jsx("ul", { css: Styles.links, "data-zds": true },
        links.map((itemGroup, index) => (jsx(React.Fragment, { key: index },
            jsx("li", { "data-zds": true },
                jsx("ul", { "data-zds": true, css: Styles.linkGroup }, itemGroup === null || itemGroup === void 0 ? void 0 : itemGroup.map((item) => {
                    const isSelected = isLinkSelected(item.href || '', selectedHref, item.shouldHighlightOnlyOnExactHref);
                    const icon = isSelected ? item.iconFilled : item.icon;
                    return (jsx("li", { key: item.text, "data-zds": true },
                        jsx(UniversalNavLink, { href: item.href, icon: icon, isSelected: isSelected, isSidebar: true, isV3Link: true, text: item.text, tag: item.tag, target: item.target, isExternal: item.target === '_blank' })));
                }))),
            index < links.length - 1 && (jsx("li", { "aria-hidden": "true", "data-zds": true },
                jsx(Divider, null)))))),
        moreLinks && (jsx("li", { css: Styles.moreLink, key: moreLinks.text, "data-zds": true },
            jsx(MoreLinksMenu, { items: moreLinks, selectedHref: selectedHref }))))));
export default InAppLinks;
//# sourceMappingURL=InAppLinks.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
